<template>
  <DataTable permissions="Prospect" :key="rows.length" :perpage.sync="query.per_page" :currentPage.sync="query.page"
    :search.sync="query.search" :total.sync="query.last_page" :rows.sync="rows" :table-fields="ProspectTableField">
    <template #cell(status)="{ status }">
      <div class="status"
        :style="`background-color: ${statusBackground(status)}1a;color: ${statusBackground(status)};text-transform: Capitalize;`">
        {{ status }}
      </div>
    </template>
  </DataTable>
</template>

<script>
import axios from '@/axios';
import DataTable from "@/components/DataTable.vue";
import { ProspectTableField } from "@/constants/table-field.js";
import { showErrorMessage } from '@/utils';

export default {
  components: { DataTable },
  data() {
    return {
      query: {
        per_page: this.$route?.query?.per_page || 10,
        page: this.$route?.query?.page || 1,
        search: this.$route?.query?.search || '',

        // hook
        last_page: 0,
      },
      rows: [],

      // constants
      ProspectTableField
    }
  },
  methods: {
    async get() {
      try {
        this.$store.dispatch('toggleLoadingProgress', true)
        const res = await axios.get(`/prospects`, {
          params: this.query
        })
        this.query.last_page = Number(res?.data?.data?.last_page) || 0
        this.query.page = Number(res?.data?.data?.current_page) || 1
        this.rows = res.data.data.data || []
      } catch (err) {
        showErrorMessage(err)
      } finally {
        this.$store.dispatch('toggleLoadingProgress', false)
      }
    },
    statusBackground(status) {
      const colorMap = {
        act: '#9B51E0',
        ask: '#2F80ED',
        appeal: '#F4AF00',
      };

      return colorMap[status.toLowerCase()] || '#27AE60';
    }
  },
  async created() {
    await this.get()
  },
  computed: {
    queryWatcher() {
      return {
        page: this.query.page,
        per_page: this.query.per_page,
        search: this.query.search,
      }
    }
  },
  watch: {
    queryWatcher(newVal, oldVal) {
      if (newVal.perpage !== oldVal.perpage || newVal.search !== oldVal.search) {
        this.query.page = 1
      }
      this.$router.replace({ query: this.query }).catch(() => { })
      this.get()
    },
    '$route': {
      handler(newVal) {
        if (Object.keys(newVal.query).length === 0) {
          this.query.page = 1
          this.$router.replace({
            query: {
              per_page: this.$route?.query?.per_page || 10,
              page: this.$route?.query?.page || 1,
              search: this.$route?.query?.search || '',
              last_page: 0,
            }
          }).catch(() => { }).finally(() => {
            this.get()
          })
        }
      }, immediate: false
    }
  }
}
</script>

<style></style>
